import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Input, Popover } from 'antd';
import api from '../../../../services/api';
import { PhoneIcon, MailIcon } from '../../../../common/icons';
import SupportPane from './SupportPane';

import './SupportBody.css';

const { TextArea } = Input;

@inject('translationsStore', 'commonStore')
@observer
export default class SupportBody extends Component {
  constructor(props) {
    super(props);

    this.state = {
      supportSending: false,
      supportMessageSent: false,
      supportMessageBody: '',
      supportErrorBody: false,
      supportErrorSending: false
    };
  }

  onFormSend = () => {
    if (this.state.supportMessageBody === '') {
      this.setState({
        supportErrorBody: true
      });
    } else {
      const {
        translationsStore,
        commonStore: { dealer }
      } = this.props;
      const [subject, message] = [translationsStore.translate('support.dashboard.formSubject').replace('__DEALER_NAME__', dealer.name), this.state.supportMessageBody];
      this.setState({
        supportSending: true,
        supportErrorBody: false,
        supportErrorSending: false
      });
      api('supportRequest', subject, message)
        .then(() => {
          this.setState({
            supportErrorSending: false,
            supportMessageSent: true
          });
        })
        .catch(() => {
          this.setState({
            supportErrorSending: true
          });
        })
        .finally(() => {
          this.setState({
            supportSending: false
          });
        });
    }
  };

  setMessageBody = e => {
    this.setState({
      supportMessageBody: e.target.value,
      supportErrorBody: false
    });
  };

  render() {
    const { translationsStore } = this.props;

    const [phone, email] = ['+39 0547 313404', 'info@myair.io'];

    return (
      <div className="SupportBody">
        <div style={{ margin: '0 auto', width: 1080 }}>
          <SupportPane
            title={translationsStore.translate('support.dashboard.channels.phone.title')}
            description={translationsStore.translate('support.dashboard.channels.phone.description')}
          >
            <div className="SupportPaneChild">
              <div>
                <div>
                  <PhoneIcon />
                </div>
                <div>{phone}</div>
              </div>
              <div>{translationsStore.translate('support.dashboard.phoneFooter')}</div>
            </div>
          </SupportPane>
          <SupportPane
            title={translationsStore.translate('support.dashboard.channels.email.title')}
            description={translationsStore.translate('support.dashboard.channels.email.description')}
          >
            <div className="SupportPaneChild">
              <div>
                <div>
                  <MailIcon />
                </div>
                <div>
                  <a href={`mailto:${email}`} style={{ color: 'var(--engine-on)' }}>
                    {email}
                  </a>
                </div>
              </div>
              <div>{translationsStore.translate('support.dashboard.emailFooter')}</div>
            </div>
          </SupportPane>
          <SupportPane
            title={translationsStore.translate('support.dashboard.channels.form.title')}
            description={translationsStore.translate('support.dashboard.channels.form.description')}
          >
            {!this.state.supportMessageSent ? (
              <div className="SupportPaneForm">
                <Popover content={translationsStore.translate('support.dashboard.errorCheckBody')} visible={this.state.supportErrorBody}>
                  <TextArea
                    placeholder={translationsStore.translate('support.dashboard.formPlaceholder')}
                    value={this.state.supportMessageBody}
                    onChange={this.setMessageBody}
                    rows={3}
                    style={{ resize: 'none' }}
                  />
                </Popover>
                <Popover content={translationsStore.translate('support.dashboard.errorCannotSend')} visible={this.state.supportErrorSending}>
                  <div>
                    <div className="SupportButton" onClick={this.onFormSend}>
                      {translationsStore.translate('support.dashboard.formSubmit')}
                    </div>
                  </div>
                </Popover>
              </div>
            ) : (
              <div className="SupportPaneFormSent">
                <div>{translationsStore.translate('support.dashboard.formSent')}</div>
              </div>
            )}
          </SupportPane>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/SupportDashboard/SupportBody/SupportBody.js